<template>
<v-app>
    <v-dialog v-model="showDialog" max-width="1000px">
        <v-card>
            <v-card-title>
                <span>{{title}} | {{totalEnvasado}} {{tableData[0] ? tableData[0].unit.name : ''}}/{{cantidadComprada}} {{tableData[0] ? tableData[0].unit.name: ''}}</span>
            </v-card-title>
            <v-card-text>
                
                <v-data-table
                    :headers="headers"
                    :items="tableData"
                    :items-per-page="5"
                    no-results-text="No hay resultados disponibles"
                    no-data-text="No hay datos disponibles"
                    class="elevation-1 datatable"
                    :hide-default-footer="true"
                    disable-pagination
                >
                    <template v-slot:item.envased="{ item }" >
                        <td class="text-center">
                            <v-text-field
                                v-model="item.envased"
                                type="number"
                                min="0"
                                step="0.05"
                                required
                                :suffix="item.unit.name"
                                :disabled="true"
                                
                            ></v-text-field>
                        </td>
                    </template>
                    <template v-slot:item.generated_sku="{ item }" >
                        <td class="text-center">
                            <v-text-field
                                v-model="item.generated_sku"
                                required
                                :rules="reglasSku"
                                @keyup.enter="consultaAjax(item)"
                                :disabled="loading"
                                :ref="'inputEan'+item.idref"
                            ></v-text-field>
                        </td>
                    </template>
                    <!--
                    <template v-slot:item.price="{ item }" >
                        <td class="text-center">
                            <v-text-field
                                v-model="item.price"
                                type="number"
                                min="0"
                                step="1"
                                required
                                :suffix="'$'"
                            ></v-text-field>
                        </td>
                    </template>
                    -->
                    <template v-slot:item.expires_at="{ item }" >
                        <td class="text-center">
                            <v-dialog
                                ref="dialog"
                                v-model="modal"
                                :return-value.sync="item.expires_at"
                                persistent
                                width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="item.expires_at"
                                    prepend-icon="event"
                                    readonly
                                    v-on="on"
                                    :disabled="true"
                                ></v-text-field>
                                </template>
                                <v-date-picker v-model="item.expires_at" scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="modal = false">Cancelar</v-btn>
                                <v-btn text color="primary" @click="$refs.dialog.save(item.expires_at)">OK</v-btn>
                                </v-date-picker>
                            </v-dialog>
                        </td>
                    </template>
                    <template v-slot:item.action="{ item }" >
                        <td class="text-center">
                            <v-btn v-if="!!item.optional" @click="eliminarFila(item)" text icon color="red">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
                
                <br>
                <v-btn @click="agregar">Agregar 1</v-btn>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="primary"
                    text
                    @click="showDialog = false"
                    >
                    Cancelar
                </v-btn>
                <v-btn
                    color="success"
                    text
                    :disabled="tableData.some(e => ( !e.envased || !e.generated_sku || !e.expires_at )) && !!valid"
                    @click="sendForm"
                    >
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-app>
</template>

<script>
export default {
    data(){
        return {
            valid: false,
            showDialog: false,
            title: '',
            headers: [
                {text: 'Cantidad a envasar', value: 'required' },
                {text: 'Cantidad envasada', value: 'envased' },
                {text: 'EAN13', value: 'generated_sku', width: '210px' },
                //{text: 'Precio venta', value: 'price' },
                {text: 'Fecha vencimiento', value: 'expires_at', width: '210px' },
                {text: 'Proveedor', value: 'supplier_name'},
                {text: 'Accion', value: 'action'},

            ],
            tableData: [],
            modal: false,
            indexSku: undefined,
            indexProveedor: undefined,
            reglasSku: [
                //value => this.isDuplicado(value)
                value => true
            ],
            cantidadComprada: 0.0,
            loading: false,
        }
    },
    created(){
        this.$parent.$on('openDialogEnvasadorDelItem', (data) => {
            this.title = data.title
            this.indexProveedor = data.indexProveedor;
            this.indexSku = data.indexSku;
            this.tableData = [];
            this.tableData = data.listaEnvasados.map(e => ({...e, supplier_id: data.supplier_id, supplier_name: data.supplier_name, blocked: false }));
            this.cantidadComprada = data.cantidadComprada;
            this.showDialog = true;    
        });
    },
    methods: {
        consultaAjax(item)
        {
            this.loading = true;
            var vm = this;
            this.axios({
                url: 'inventory/preg_product_sku',
                method: 'POST',
                data: {
                    sku: item.generated_sku
                }
            }).then( response => {
                console.log(response.data);
                if(item.unit.id != response.data.unit_id){
                    vm.$bvToast.toast('El EAN escaneado no corresponde a este producto', {
                        title: `Error`,
                        variant: 'danger',
                        solid: true,
                        toaster: 'b-toaster-bottom-center'
                    });
                    vm.loading = false;
                    return;
                }
                if(vm.isDuplicado(item.generated_sku))
                {
                    item.envased = parseFloat(response.data.quantity);
                    item.blocked = true;
                    let indiceProximo = vm.tableData.indexOf(item)+1;
                    if(indiceProximo < vm.tableData.length)
                    {
                        vm.$nextTick(() => {
                            vm.$refs['inputEan'+vm.tableData[indiceProximo].idref].focus();
                        });
                    }
                }
                vm.loading = false;
            }).catch( error => {
                vm.loading = false;
            });
            console.log('se apreto el enter');
        },
        isDuplicado(value)
        {
            let contador = 0;
            this.tableData.forEach( elem => {
                if( elem.envased > 0.0 ){
                    if(elem.generated_sku == value){
                        contador++;
                    }
                }
                
            });
            return contador < 2 ? true : 'Sku repetido'
        },
        agregar()
        {
            //let nuevo = {};
            this.tableData.push({
                envased: 0.0,
                expires_at: new Date().toISOString().substr(0, 10),
                generated_sku: '',
                id: this.tableData[0].id,
                required: this.tableData[0].required,
                unit: this.tableData[0].unit,
                supplier_id: this.tableData[0].supplier_id,
                supplier_name: this.tableData[0].supplier_name,
                optional: true,
            });
        },
        sendForm(){
            /*
            if( this.tableData.some( e => this.isDuplicado(e.generated_sku) == 'Sku repetido' ) ){
                this.$bvToast.toast('Debes corregir el problema: "Sku repetido"', {
                    title: `Error`,
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-bottom-center'
                });
                return;
            }
            */
            console.log('sendForm');
            this.$emit('finish', {listaEnvasados: this.tableData, indexSku: this.indexSku, indexProveedor: this.indexProveedor });
           
            this.showDialog = false;
        },
        eliminarFila(item){
            const index = this.tableData.indexOf(item);
            this.tableData.splice(index,1);
        },
    },
    computed: {
        totalEnvasado()
        {   
            let acum = 0.0;
            this.tableData.forEach(e => {
                acum+= parseFloat(e.envased);
            })
            return acum;
        }
    }
}
</script>